import Vue from 'vue';
import Vuex from 'vuex';
import track from './modules/track';
import news from './modules/news';
import getters from './getters';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    track,
    news
  },
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js